import { SubTaskType } from '@dadohr/shared/domainTypes/experience';

export const DEV_FIXTURE: any = {
  id: 'T6WbXg2KfbjpPHjbPaTvxaVKaRcIEjxyC9aWuMM',
  collection: 'experiencesDenormalizedV1',
  data: {
    accessToken: 'T6WbXg2KfbjpPHjbPaTvxaVKaRcIEjxyC9aWuMM',
    expId: 'eW2J4-PoNkwOi',
    orgId: 'v12cu2NIl',
    tz: 'Europe/Berlin',
    org: {
      name: 'Demo Company',
      domain: 'https://demo.dadohr.com'
    },
    userId: '0b_THixKX1Ay',
    user: {
      middleName: '',
      location: 'New York',
      lastName: 'Arias',
      firstName: 'Iva',
      active: true,
      preferredName: 'Iva',
      email: 'iva.arias@jer.test',
      team: 'Omicron',
      terminationDate: null,
      orgId: 'v12cu2NIl',
      department: 'Marketing',
      gender: 'f',
      managerId: 'EhoOvtivHx-E',
      role: 'Facebook Poster',
      hireDate: {
        _seconds: 1597528800,
        _nanoseconds: 0
      },
      alternateId: '4973828402839552',
      customFields: {}
    },
    templateId: 'Ci4fx488hc3W',
    title: 'Onboarding - US',
    description: {
      t:
        "Here you'll find the steps you need to complete for your onboarding. This will ensure we have all the documents we need from you, as well as give you a great introduction to the company and how we work. If you have any questions, reach out to your manager or your People Partner.",
      v: 1
    },
    status: 'LATE',
    startsAt: {
      _seconds: 1599469200,
      _nanoseconds: 0
    },
    tasks: [
      {
        id: 'D0ZedO4l-4Add',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: '27LNHsP4yAtX',
        status: 'COMPLETE',
        title: 'Submit I-9 Form',
        description: {
          t: '',
          v: 1
        },
        start: {
          _seconds: 1599469200,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: '9tOHkRWRcG_9s',
            templateId: '95iMbcnQ-xNy',
            status: 'DONE',
            type: SubTaskType.SUBMIT,
            data: {
              label: 'I9-Form to Workday',
              to: { type: 'EMAIL', email: 'Workday' },
              fileNameFormat:
                '[{{ experience.title }}] {{ participant.fullName }} - {{ task.title }}: {{ label }}'
            }
          }
        ]
      },
      {
        id: 'BBxlW-ATyqQrw',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 'JdNwckG2CyJl',
        status: 'LATE',
        title: 'Submit Bank Details',
        description: {
          v: 1,
          t:
            'Please fill in the SWIFT, IBAN or Bank/Account Number fields in your employee profile  in Workday by following the link below. Make sure to complete this until the deadline so payment can be made this month.'
        },
        start: {
          _seconds: 1599469200,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: '0CGX8oBVm3AyJ',
            templateId: 'f3pT1tMx_Eq3',
            status: 'OPEN',
            type: SubTaskType.SUBMIT,
            data: {
              label: 'Bank Details to Workday',
              to: { type: 'EMAIL', email: 'Workday' },
              fileNameFormat:
                '[{{ experience.title }}] {{ participant.fullName }} - {{ task.title }}: {{ label }}'
            }
          }
        ]
      },
      {
        id: 'Oz5ROYQsAj6PM',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: '4kJUErp7OfZ7',
        status: 'COMPLETE',
        title: 'Submit Contract',
        description: {
          t: '',
          v: 1
        },
        start: {
          _seconds: 1599469200,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: '_UrFYbq_0sOe9',
            templateId: 'oPzqQeaf1Vni',
            status: 'DONE',
            type: SubTaskType.SUBMIT,
            data: {
              to: { type: 'EMAIL', email: 'DocuSign' },
              label: 'Signed Contract to Docusign',
              fileNameFormat:
                '[{{ experience.title }}] {{ participant.fullName }} - {{ task.title }}: {{ label }}'
            }
          }
        ]
      },
      {
        id: 'fPpKKUTCeZlfI',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 'dEFz9HZZ-0oG',
        status: SubTaskType.CONFIRM,
        title: 'Take Security Training',
        description: {
          v: 1,
          t: ''
        },
        start: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1601888400,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: '-XPtNa7GSRmk8',
            templateId: 'jEfJlek9jLQ_',
            status: 'DONE',
            type: SubTaskType.CONFIRM,
            data: {
              label: 'Security Training in TalentLMS'
            }
          }
        ]
      },
      {
        id: 'B9xZ-NrKmO0-L',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: '9g60K5cmT3x-',
        status: 'COMPLETE',
        title: 'Watch Fire and Safety Training',
        description: {
          t: '',
          v: 1
        },
        start: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1602493200,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'aL8gu8Xbk-BuO',
            templateId: 'OURxnz6Oz3Ru',
            status: 'DONE',
            type: SubTaskType.CONFIRM,
            data: {
              label: 'Fire and Safety Training in TalentLMS'
            }
          }
        ]
      },
      {
        id: 'a-_AAh6QpyqXx',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: '8M7g3lCwlR2T',
        status: 'LATE',
        title: 'Meet Manager (1:1)',
        description: {
          v: 1,
          t:
            'A 1-1 is a dedicated space on the calendar and in your mental map for open-ended and anticipated conversation between you and your manager. Unlike status reports or tactical meetings, the 1-1 meeting is a place for coaching, mentorship, giving context, or even venting.'
        },
        start: {
          _seconds: 1600678800,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1601888400,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: '0Ofd7TUvjvIRb',
            templateId: 'FUimInRLlgVP',
            status: 'OPEN',
            type: SubTaskType.MEET,
            data: {
              role: 'MANAGER'
            }
          }
        ]
      },
      {
        id: 'K2Z-v6ZFu17rd',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 's1V-i21LM7H3',
        status: 'COMPLETE',
        title: '30 Days Check-in with HR',
        description: {
          t: '',
          v: 1
        },
        start: {
          _seconds: 1601888400,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1603357200,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'CNnB94HklnZVH',
            templateId: 'knGQFtUbY1cq',
            status: 'DONE',
            type: SubTaskType.MEET,
            data: {
              role: 'HR'
            }
          }
        ]
      },
      {
        id: 'xzKF4ZPngmG96',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 'dKGf4g2-32Jg',
        status: 'RUNNING',
        title: 'Meet Manager (1:1)',
        description: {
          t:
            'A 1-1 is a dedicated space on the calendar and in your mental map for open-ended and anticipated conversation between you and your manager. Unlike status reports or tactical meetings, the 1-1 meeting is a place for coaching, mentorship, giving context, or even venting.',
          v: 1
        },
        start: {
          _seconds: 1603098000,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1604307600,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'J-cZ14doXdKj0',
            templateId: 'ailU8BCyfxh4',
            status: 'OPEN',
            type: SubTaskType.MEET,
            data: {
              role: 'MANAGER'
            }
          }
        ]
      },
      {
        id: 'EdJ9KsbsFEIEr',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 'JDM9zsz6nATn',
        status: 'NOT_STARTED',
        title: 'Meet Manager (1:1)',
        description: {
          t:
            'A 1-1 is a dedicated space on the calendar and in your mental map for open-ended and anticipated conversation between you and your manager. Unlike status reports or tactical meetings, the 1-1 meeting is a place for coaching, mentorship, giving context, or even venting.',
          v: 1
        },
        start: {
          _seconds: 1606122000,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1607331600,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'ycRHDDh0u89Tu',
            templateId: 'b8TMl31MKN2K',
            status: 'OPEN',
            type: SubTaskType.MEET,
            data: {
              role: 'MANAGER'
            }
          }
        ]
      },
      {
        id: 'aysrszGFqpH7d',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: 'AX9OKjFou_aV',
        status: 'RUNNING',
        title: 'Request Peer Feedback',
        description: {
          v: 1,
          t:
            'Follow the link to Small Improvements. Use the Request Feedback feature to request feedback from your manager and at least 3 colleagues.'
        },
        start: {
          _seconds: 1603357200,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1606986000,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'asdasdadas',
            templateId: 'asdasdsada',
            status: 'OPEN',
            type: SubTaskType.WATCH,
            data: {
              url: 'https://www.youtube.com/watch?v=N8naNc9tuhM'
            }
          },
          {
            id: 'tblNP8nhefTuv',
            templateId: 'b3NLR5GN2rbB',
            status: 'OPEN',
            type: SubTaskType.CONFIRM,
            data: {
              label: 'Peer Feedback in Small Improvements'
            }
          }
        ]
      },
      {
        id: 'snb1Ya39Peuh2',
        experienceId: 'eW2J4-PoNkwOi',
        templateId: '21ApWT5bFD9j',
        status: 'NOT_STARTED',
        title: '90 Days Check-in',
        description: {
          v: 1,
          t: ''
        },
        start: {
          _seconds: 1607331600,
          _nanoseconds: 0
        },
        end: {
          _seconds: 1608541200,
          _nanoseconds: 0
        },
        subTasks: [
          {
            id: 'Rh6tu7e-A4-UE',
            templateId: '218bswoVR22n',
            status: 'OPEN',
            type: SubTaskType.MEET,
            data: {
              role: 'MANAGER'
            }
          }
        ]
      }
    ],
    contacts: [
      {
        type: 'MAIL',
        name: 'the People Team',
        email: 'people@dadohr.com'
      }
    ],
    v: 1
  }
};
